export default __webpack_public_path__ + "static/media/Pedestal Icons_MegaMaster.83b419c6.svg";